/**
 * The one-line address of a depot, built from the parts the place search
 * filled in. Used by the depot register table and by the depot form, so both
 * show the depot's place the same way.
 */
export const formatDepotAddress = (parts: {
  address: string | null;
  postcode: string | null;
  city: string | null;
}): string =>
  [parts.address, [parts.postcode, parts.city].filter(Boolean).join(" ")]
    .map((x) => (x ?? "").trim())
    .filter(Boolean)
    .join(", ");
